// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store/index.js'
import router from './router'
import {ButtonGroup, Button, Select, Table, TableColumn, Option, Tabs, Dialog, Collapse, CollapseItem, Divider, Form, Steps, Popover, Tag, Progress, Step, Badge, Pagination, DatePicker, PageHeader, Card, Avatar, Checkbox, Tree, Cascader, MessageBox, Tooltip, Autocomplete, FormItem, TabPane, InputNumber, Loading, Alert, Input, RadioGroup, Radio, RadioButton, Dropdown, DropdownMenu, DropdownItem, Upload, Message, Slider, Switch, Drawer} from 'element-ui'
import '../theme/index.css'
import AFTableColumn from 'af-table-column'
let echarts = require('echarts/lib/echarts')
import api from './api/api'
import http from './api/config'
import md5 from 'js-md5'


// 引入折线图等组件
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
// 引入雷达图
require('echarts/lib/chart/radar')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/toolbox')
require('echarts/lib/component/dataZoom')

Vue.prototype.$md5 = md5
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api
Vue.prototype.$http = http
Vue.use(ButtonGroup)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(PageHeader)
Vue.use(Badge)
Vue.use(Card)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dropdown)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Tree)
Vue.use(Autocomplete)
Vue.use(Cascader)
Vue.use(Avatar)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Loading)
Vue.use(Steps)
Vue.use(Tooltip)
Vue.use(Input)
Vue.use(Step)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Alert)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Divider)
Vue.use(Form)
Vue.use(InputNumber)
Vue.use(FormItem)
Vue.use(AFTableColumn)
Vue.use(Upload)
Vue.use(Slider)
Vue.use(Switch)
Vue.use(Drawer)
Vue.use(Vuex)
// Vue.use(Message)
Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$customToMoney = function (num) {
  if (num > 100) {
    let num1 = String(num)
    num = num1.split('.')
    let result = num[0].split('').reverse().reduce((rev, next, index) => {
      return ((index % 3) ? next : (next + ',')) + rev
    })
    if (num[1]) {
      result = result + '.' + num[1]
      return result
    } else {
      return result
    }
  } else if (num < 0) {
    let num1 = String(num).slice(1, num.length)
    num = num1.split('.')
    let result = num[0].split('').reverse().reduce((rev, next, index) => {
      return ((index % 3) ? next : (next + ',')) + rev
    })
    if (num[1]) {
      result = result + '.' + num[1]
      return `-${result}`
    } else {
      return `-${result}`
    }
  } else {
    return num
  }
}
Vue.prototype.$downloadFile = function (data, fileName) {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
// 中央事件总线
Vue.prototype.$bus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

if (process.env.NODE_ENV === "development") {
  console.log(process.env)
  window._env_ = {
    api_url: process.env.api_url,
    dynamic_calculate: process.env.dynamic_calculate
  }
}



// WEBPACK FOOTER //
// ./src/main.js